import React, { useEffect, useState } from "react";
import { FormControl, MenuItem, Select, Slider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SaveWatermarkSettings, GetWatermarkSettings } from "../../Services/Watermark";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const WatermarkSettings: React.FunctionComponent<{ className?: string, svg?: any, text?: string, onChangeMessagehandler: any }> = (props) => {

    const { t } = useTranslation();
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [selectPosition, setSelectPosition] = useState<string>("");
    const [transparent, setTransparent] = useState<number>(0);
    const [logo, setLogo] = useState<any | null>(null);
    const [watermarkDialogOpen, setWatermarkDialogOpen] = useState(false);

    useEffect(() => {
        GetWatermarkSettings().then((data: any) => {
            if (data) {
                setSelectPosition(data.position || "");
                setTransparent(Number(data.transparency || 0));
                setLogo(data.watermarkLogo ? { id: 1, src: data.watermarkLogo, ext: "png" } : null);
            }
        }).catch(() => { })
    }, [])

    const HandleChangeLogo = (event: any) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64 = reader.result as string;
            const ext = file.type.split('/')[1];
            setLogo({ id: 1, src: base64, ext: ext });
        };
    }

    const handleDeleteLogo = () => {
        setLogo(null);
    };

    const handleChangeTransparent = (event: any) => {
        setTransparent(event.target.value)
    }

    const handleSelectPosition = (event: any) => {
        setSelectPosition(event.target.value)
    }

    const handleSave = async () => {
        try {
            setIsSaving(true);
            await SaveWatermarkSettings({
                watermarkLogo: logo?.src || undefined,
                position: selectPosition,
                transparency: transparent,
            });
            props.onChangeMessagehandler("success", "Saved settings successfully");

        } catch (error: any) {
            props.onChangeMessagehandler("error", "Save failed");
        } finally {
            setIsSaving(false);
            setWatermarkDialogOpen(false);
        }
    }

    return (
        <>
            <button type="button" className={props.className} onClick={() => setWatermarkDialogOpen(true)} >
                {props.text}
                {props.svg}
            </button>

            <BootstrapDialog
                onClose={() => setWatermarkDialogOpen(false)}
                aria-labelledby="customized-dialog-title"
                open={watermarkDialogOpen}
                fullWidth={true}
                maxWidth={"sm"}
            >
                <DialogTitle >
                    {t("settings.watermark")}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setWatermarkDialogOpen(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[800],
                    })}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>

                    <div className="">
                        <div className="row mb-4">
                            <label className="title-20 bold-700 mb-3 color-black" htmlFor="Upload">{t("addWatermark.title")}</label>
                            {!logo ?
                                <div className="upload-xml">
                                    <label className="form_container_1 padd-15" id="upload-container">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.3332 2.66699H11.9998C5.33317 2.66699 2.6665 5.33366 2.6665 12.0003V20.0003C2.6665 26.667 5.33317 29.3337 11.9998 29.3337H19.9998C26.6665 29.3337 29.3332 26.667 29.3332 20.0003V13.3337" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <g opacity="0.4">
                                                <path d="M23.9995 10.666V2.66602L26.6662 5.33268" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M23.9997 2.66602L21.333 5.33268" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                            <path opacity="0.4" d="M3.56006 25.2661L10.1334 20.8528C11.1867 20.1461 12.7067 20.2261 13.6534 21.0394L14.0934 21.4261C15.1334 22.3194 16.8134 22.3194 17.8534 21.4261L23.4001 16.6661C24.4401 15.7728 26.1201 15.7728 27.1601 16.6661L29.3334 18.5328" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <p>{t("addWatermark.uploadWatermark")}</p>
                                        <input className="form__file" id="upload-files" accept='image/*' type="file" onChange={HandleChangeLogo} />
                                    </label>
                                    <div id="files-list-container"></div>
                                </div> :
                                <div id="read-watermark">
                                    <div style={{ position: "relative", display: "inline-block" }}>
                                        <img src={logo.src} className="previewImage" style={{ width: "190px", marginLeft: "0px" }} />
                                        <button
                                            style={{ position: "absolute", top: "5px", right: "25px", borderRadius: "50px", color: "#716BE3", border: "2px solid #716BE3", background: "#FFF" }}
                                            onClick={handleDeleteLogo}
                                        >
                                            <i className="fa-solid fa-xmark"></i>
                                        </button>
                                    </div>
                                </div>}
                        </div>

                        <FormControl fullWidth>
                            <Select
                                className="custom-select mb-4"
                                displayEmpty
                                inputProps={{ 'aria-label': 'Select' }}
                                value={selectPosition || ""}
                                onChange={handleSelectPosition}
                                sx={{
                                    border: "1px solid #746AFF",
                                    background: "#FFFFFF !important",
                                    color: "#746AFF",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#746AFF"
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#746AFF"
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: "#FFFFFF"
                                        }
                                    }
                                }}
                            >
                                <MenuItem value="" disabled> {t("addWatermark.selectPosition")} </MenuItem>
                                <MenuItem value={"Top Left"}>{t("addWatermark.topLeft")}</MenuItem>
                                <MenuItem value={"Top Right"}>{t("addWatermark.topRight")}</MenuItem>
                                <MenuItem value={"Center"}>{t("addWatermark.center")}</MenuItem>
                                <MenuItem value={"Bottom Left"}>{t("addWatermark.bottomLeft")}</MenuItem>
                                <MenuItem value={"Bottom Right"}>{t("addWatermark.bottomRight")}</MenuItem>
                            </Select>
                        </FormControl>

                        <label className="form-label  mb-3" htmlFor="selectTypeOpt">{t("addWatermark.transparency")}</label>
                        <div className="d-flex align-items-center mb-4">
                            <span className="para-14 bold-500 font-Inter color-344054">0%</span>
                            <Slider aria-label="Image Score" sx={{ color: "#6366F1", marginRight: "15px", marginLeft: "15px", height: "8px", borderRadius: "8px" }} value={transparent || 0} onChange={handleChangeTransparent} valueLabelDisplay="auto" max={100} min={0} />
                            <span className="para-14 bold-500 font-Inter color-344054">100%</span>
                        </div>

                        <div className="d-flex justify-content-end">
                            <button type="button" disabled={isSaving || !selectPosition} className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 width-auto`} onClick={handleSave}>
                                {isSaving ? "Saving..." : t("save")}
                            </button>
                        </div>
                    </div>
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}

export default WatermarkSettings;


